export const prepareViewSettingsRequest = (path, query) => {
  const { catalogId, viewId, scope } = path;

  let url = `catalogs/${catalogId}`;

  if (viewId && viewId !== '0') {
    url += `/views/${viewId}/viewSettings`;
  } else {
    url += `/viewSettings`;
  }

  if (scope) {
    url += `/${scope}`;
  }

  return {
    url,
    query,
  };
};
